import styles from './rss-link.module.css';

type Props = {
  readonly companyId: number;
};

export function CompanyInformationRssLink({companyId}: Props) {
  return (
    <a
      href={`/companyrdf.php?company_id=${companyId}`}
      target='_blank'
      className={styles.link}
      rel='noreferrer'
    >
      <RssIcon className={styles.icon} />
      <span>RSS</span>
    </a>
  );
}

function RssIcon({...props}) {
  return (
    <svg
      aria-hidden='true'
      width='19'
      height='19'
      viewBox='0 0 19 19'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_3726_11791)'>
        <g>
          <g>
            <path
              d='M5 12.5C5.828 12.5 6.5 13.172 6.5 14C6.5 14.828 5.828 15.5 5 15.5C4.172 15.5 3.5 14.828 3.5 14C3.5 13.172 4.172 12.5 5 12.5ZM3.5 7.5H4.5C8.359 7.5 11.5 10.641 11.5 14.5V15.5H9.5V14.5C9.5 11.743 7.257 9.5 4.5 9.5H3.5V7.5ZM3.5 3.5H4.5C10.565 3.5 15.5 8.435 15.5 14.5V15.5H13.5V14.5C13.5 9.537 9.463 5.5 4.5 5.5H3.5V3.5ZM2.5 0.5C2.226 0.5 1.965 0.558 1.727 0.658C1.246 0.861 0.861 1.246 0.658 1.727C0.608 1.845 0.567 1.969 0.541 2.098V2.1C0.515 2.229 0.5 2.363 0.5 2.5V16.5C0.5 16.637 0.514 16.771 0.541 16.9V16.902C0.568 17.031 0.607 17.155 0.658 17.273C0.861 17.754 1.246 18.139 1.727 18.342C1.845 18.392 1.969 18.433 2.098 18.459H2.1C2.229 18.485 2.363 18.5 2.5 18.5H16.5C16.773 18.5 17.035 18.444 17.273 18.342C17.754 18.139 18.139 17.754 18.342 17.273C18.444 17.035 18.5 16.773 18.5 16.5V2.5C18.5 2.227 18.444 1.965 18.342 1.727C18.139 1.246 17.754 0.861 17.273 0.658C17.155 0.607 17.031 0.568 16.902 0.541H16.9C16.771 0.514 16.637 0.5 16.5 0.5H2.5Z'
              fill='black'
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_3726_11791'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(0.5 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
